
export function formatPrice(price) {
  if (price) {
    return price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
  }
  return '0';
}
